import { render, staticRenderFns } from "./ModalPaymentAdd.vue?vue&type=template&id=308923b2"
import script from "./ModalPaymentAdd.vue?vue&type=script&lang=js"
export * from "./ModalPaymentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308923b2')) {
      api.createRecord('308923b2', component.options)
    } else {
      api.reload('308923b2', component.options)
    }
    module.hot.accept("./ModalPaymentAdd.vue?vue&type=template&id=308923b2", function () {
      api.rerender('308923b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/Modals/ModalPaymentAdd.vue"
export default component.exports